import React from 'react';
import '../App.css';
import WelComeLayer from '../components/WelcomeLayer'
import 'bootstrap/dist/css/bootstrap.min.css';
import {IMAGES, MESSAGES} from "../util/Messages";
import InscriptionFormBacAffiliate from "../components/InscriptionFormBacAffiliate";


export default class InscriptionBacAffiliateApp extends React.Component {
  render() {
    return (
      <>
        <WelComeLayer logo={IMAGES.colsubidio} footer={IMAGES.footerColsubsidio} 
        message={MESSAGES.WELCOME_MESSAGE_COLSUBSIDIO}/>
        <InscriptionFormBacAffiliate />
      </>
    );
  }
}
